import { render, staticRenderFns } from "./WbApp.vue?vue&type=template&id=66cebcd4&scoped=true"
import script from "./WbApp.vue?vue&type=script&lang=js"
export * from "./WbApp.vue?vue&type=script&lang=js"
import style0 from "./WbApp.vue?vue&type=style&index=0&id=66cebcd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66cebcd4",
  null
  
)

export default component.exports